import React, {useState} from 'react';
import countries from "./countries"
import fields from './fields';
import {validateEmail} from "../../services/functions";

const UserDetails = (props)=>{

    const {
        fieldsState,
        setFields,
        setCurrency,
    } = props;


    const fieldChanged = (id,value)=>{
        const newFields = {...fieldsState,id:value}
        setFields(prevState => {
            return {...prevState, [id]: value}
        })

        if(id === "country") setCurrency(value === "Israel"? "shekels" : "dollars");
    }

    const inputType ={
        docEmail: "email",
        birth: "date",
    }

    const getErrors = (id)=> (id === "docEmail" && fieldsState[id] && !validateEmail(fieldsState[id]))? "error" : "";


    const getField = (field)=>{
        const {
            type,
            id,
            classes,
            placeholder,
            options
        } = field;

        switch (type) {
            case "input":
                return(
                    <>
                        <input
                            key={id}
                            type={inputType[id]? inputType[id] : "text"}
                            className={`${classes} ${getErrors(id)}`}
                            placeholder={placeholder}
                            onChange={(e)=>{fieldChanged(id,e.target.value)}}
                            value={fieldsState[id]}
                        />
                        {id === "birth" && <span className='date-label'>{placeholder}</span>}
                    </>
                );
            case "select":
                const isCountries = (id === "country");
                const selectOptions = isCountries? countries :options;
                return(
                    <select
                        onChange={(e)=>{fieldChanged(id,e.target.value)}}
                        value={fieldsState[id]}
                    >
                        <option
                            key="disabled" selected hidden
                        >
                            {placeholder}
                        </option>

                        {selectOptions.map((option,index)=>{
                                const optionText = isCountries? option.name : option;
                                return(
                                    <option
                                        key={index}
                                        value={optionText}>
                                        {optionText}
                                    </option>
                                )
                            }
                        )}
                    </select>
                );
                break;
        }
    }

    return (
        <form>
            <h3>{abraStr.patient}</h3>
            <div className='flex patient'>
                {fields.patient.map(field=>getField(field))}
            </div>

            <h3>{abraStr.doctor}</h3>
            <div className='flex doctor'>
                {fields.doctor.map(field=>getField(field))}
            </div>

        </form>
    );
}

export default UserDetails;